"use client"

import { useEffect } from "react"

export default function AntiIframe() {
  useEffect(() => {
    // Check if the app is being loaded in an iframe
    if (window !== window?.top) {
      // If we're in an iframe, redirect to the top window
      if (window.top) {
        window.top.location.href = window.location.href
      }
    }
  }, [])

  return null // This component doesn't render anything
}
